/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { ExcIceGsmV1InstrumentState } from '@interxfi/types';
import { schema } from 'normalizr';

export const EXC_ICE_GSM_V1_INSTRUMENT_STATE_ENTITY_NAME = 'exc.ice.gsm.v1.Instrument';
export const excIceGsmV1InstrumentStateEntity = new schema.Entity<ExcIceGsmV1InstrumentState>(EXC_ICE_GSM_V1_INSTRUMENT_STATE_ENTITY_NAME, {}, { idAttribute: 'instrumentId' });

